import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export default class SubItemsAjax extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      search: ""
    };
  }

  onSearchChange = e => {
    this.setState({ search: e.target.value });
  };

  getOptions = () => {
    return this.props.options.filter(option => {
      return (
        option.name.toLowerCase().indexOf(this.state.search.toLowerCase()) >= 0
      );
    });
  };

  render() {
    const { onBack, onSelect, title, value, name } = this.props;

    const options = this.getOptions();

    return (
      <div className="plus-control__controls">
        <div className="plus-control__item back" onClick={onBack}>
          Назад
        </div>

        <div className="plus-control__item-section">{title}</div>

        <div className="plus-control__search-item">
          <input
            type="text"
            className="plus-control__search-input"
            value={this.state.search}
            onChange={this.onSearchChange}
          />
          <span className="plus-control__search-icon" />
        </div>

        <div className="plus-control__options">
          {options.map(option => (
            <div
              key={option.value}
              className={classnames("plus-control__item shifted", {
                active: option.value == value
              })}
              onClick={() => {
                onSelect({ [name]: option.value });
              }}
            >
              {option.name}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

SubItemsAjax.propTypes = {
  title: PropTypes.string,

  onBack: PropTypes.func.isRequired,
  onSelect: PropTypes.func,

  options: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  name: PropTypes.string
};

SubItemsAjax.defaultProps = {
  options: []
};
